import React, { useContext, useState } from "react";
import AdvisorNavbar from "../layout/AdvisorNavbar";
import LocContext from "../context/locContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FiTrendingUp, FiTrendingDown, FiDownload, FiFileText, FiBarChart2 } from "react-icons/fi";
import { NavLink } from "react-router-dom";

export default function ClientPortfolio() {
  const { userData } = useContext(LocContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("id") || "1";

  const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const [portfolioData] = useState({
    totalValue: 2500000,
    totalInvested: 2000000,
    totalGains: 500000,
    gainPercentage: 25,
    xirr: 12.5,
    clientName: "Rajesh Kumar",
  });

  const [holdings] = useState([
    { id: 1, schemeName: "HDFC Equity Fund", category: "Equity", invested: 500000, currentValue: 625000, gains: 125000, gainPercent: 25, units: 5000 },
    { id: 2, schemeName: "SBI Bluechip Fund", category: "Equity", invested: 750000, currentValue: 900000, gains: 150000, gainPercent: 20, units: 7500 },
    { id: 3, schemeName: "ICICI Prudential Debt Fund", category: "Debt", invested: 500000, currentValue: 525000, gains: 25000, gainPercent: 5, units: 50000 },
    { id: 4, schemeName: "Axis Midcap Fund", category: "Equity", invested: 250000, currentValue: 350000, gains: 100000, gainPercent: 40, units: 2500 },
  ]);

  const handleGenerateReport = () => {
    alert("Report generation functionality will be implemented");
  };

  return (
    <>
    <AdvisorNavbar />
    <div className="page-content" style={{ background: "#f1f5f9" }}>

          {/* Header */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px" }}>
            {/* <div style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
              padding: "20px",
              borderRadius: "12px",
              borderBottom: "3px solid #39b2b4",
            }}> */}
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  <h2 className="mb-1" >
                    Client Portfolio - {portfolioData.clientName}
                  </h2>
                <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/agent/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Client Portfolio
                  </li>
                </ol>
              </nav>

                </div>
                <button
                  className="btn btn-primary"
                  onClick={handleGenerateReport}
                  style={{
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FiFileText style={{ fontSize: "18px" }} />
                  Generate Report
                </button>
              {/* </div> */}
            </div>
          </div>

          {/* Portfolio Summary Cards */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-md-6 col-lg-3">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                  borderLeft: "4px solid #1bafb4",
                }}>
                  <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Total Value</p>
                  <h3 className="mb-0" style={{ color: "#1bafb4",  }}>
                    {formatINR(portfolioData.totalValue)}
                  </h3>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                  borderLeft: "4px solid #1bafb4",
                }}>
                  <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Total Invested</p>
                  <h3 className="mb-0" style={{ color: "#1bafb4",  }}>
                    {formatINR(portfolioData.totalInvested)}
                  </h3>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)",
                  borderLeft: "4px solid #10b981",
                }}>
                  <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Total Gains</p>
                  <div className="d-flex align-items-center">
                    <FiTrendingUp style={{ fontSize: "24px", color: "#10b981", marginRight: "8px" }} />
                    <div>
                      <h3 className="mb-0" style={{ color: "#10b981",  }}>
                        {formatINR(portfolioData.totalGains)}
                      </h3>
                      <span style={{ color: "#10b981", fontSize: "14px", fontWeight: "500" }}>
                        ({portfolioData.gainPercentage}%)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                  borderLeft: "4px solid #1bafb4",
                }}>
                  <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>XIRR</p>
                  <h3 className="mb-0" style={{ color: "#1bafb4",  }}>
                    {portfolioData.xirr}%
                  </h3>
                </div>
              </div>
            </div>
          </div>

          {/* Holdings Table */}
          <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
            <div className="card-body p-4">
              <div style={{
                background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                padding: "16px",
                borderRadius: "12px",
                borderBottom: "3px solid #39b2b4",
                marginBottom: "24px",
              }}>
                <h4 className="mb-0">
                  Holdings
                </h4>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr style={{ background: "#f8fafc" }}>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Scheme Name</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Category</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Invested</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Current Value</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Gains</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Units</th>
                    </tr>
                  </thead>
                  <tbody>
                    {holdings.map((holding) => (
                      <tr key={holding.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                        <td style={{ padding: "12px", color: "#1e293b", fontWeight: "500" }}>{holding.schemeName}</td>
                        <td style={{ padding: "12px" }}>
                          <span className="badge" style={{
                            background: holding.category === "Equity" ? "#dbeafe" : "#fef3c7",
                            color: holding.category === "Equity" ? "#2563eb" : "#d97706",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}>
                            {holding.category}
                          </span>
                        </td>
                        <td style={{ padding: "12px", color: "#1e293b" }}>{formatINR(holding.invested)}</td>
                        <td style={{ padding: "12px", color: "#1e293b", fontWeight: "600" }}>{formatINR(holding.currentValue)}</td>
                        <td style={{ padding: "12px" }}>
                          <div className="d-flex align-items-center">
                            {holding.gains >= 0 ? (
                              <FiTrendingUp style={{ fontSize: "18px", color: "#10b981", marginRight: "4px" }} />
                            ) : (
                              <FiTrendingDown style={{ fontSize: "18px", color: "#ef4444", marginRight: "4px" }} />
                            )}
                            <span style={{
                              color: holding.gains >= 0 ? "#10b981" : "#ef4444",
                              fontWeight: "600",
                            }}>
                              {formatINR(holding.gains)} ({holding.gainPercent}%)
                            </span>
                          </div>
                        </td>
                        <td style={{ padding: "12px", color: "#64748b" }}>{holding.units.toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="card shadow-sm mt-4" style={{ borderRadius: "12px", border: "none", background: "#f0f9ff" }}>
            <div className="card-body p-4">
              <div className="d-flex align-items-start">
                <FiBarChart2 style={{ fontSize: "24px", color: "#1bafb4", marginRight: "12px", marginTop: "2px" }} />
                <div>
                  <h6 className="mb-2" style={{ color: "#1bafb4", fontSize: "16px", fontWeight: "600" }}>
                    Important Disclaimer
                  </h6>
                  <p className="mb-0" style={{ color: "", fontSize: "14px" }}>
                    This is a read-only view of the client's portfolio. You cannot execute transactions directly. 
                    All investment decisions must be authorized by the client. This information is for advisory purposes only.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  );
}
